// extracted by mini-css-extract-plugin
export var char = "styles-module--char--72N94";
export var moveText = "styles-module--move-text--dOqro";